export default "__VITE_ASSET__D3f6ASvk__"